import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import NotificationTypeEdit from "./NotificationTypeEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Notification Type List
 * @returns {React.ReactElement}
 */
function NotificationTypeList() {
    const { fetch, load } = useList("notificationType");

    const data = Store.useState("notificationType");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("notificationType");


    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "notificationTypeID", elemID, "name");

    return <Main>
        <Header message="NOTIFICATION_TYPES_NAME" icon="notification-type">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="NOTIFICATION_TYPES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="fullName"       message="GENERAL_NAME"                   isTitle />
                    <TableHeader field="activityName"   message="ACTIVITIES_SINGULAR"            />
                    <TableHeader field="showInRegister" message="NOTIFICATION_TYPES_IN_REGISTER" maxWidth="90" align="center" />
                    <TableHeader field="finalPosition"  message="GENERAL_POSITION"               maxWidth="80" align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.notificationTypeID} elemID={elem.notificationTypeID}>
                        <TableCell message={elem.fullName}           />
                        <TableCell message={elem.forActivityText}    />
                        <TableCell message={elem.showInRegisterText} />
                        <TableCell message={elem.finalPosition}      />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="NOTIFICATION_TYPES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="NOTIFICATION_TYPES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <NotificationTypeEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="NOTIFICATION_TYPES_DELETE_TITLE"
            message="NOTIFICATION_TYPES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default NotificationTypeList;
